// extracted by mini-css-extract-plugin
module.exports = {"pinTopItem":"styles_pinTopItem__Kannm","pinBottomItem":"styles_pinBottomItem__LDWz5"};